import SubscriptionArticleResourceListResultModel from '../../generated/types/model/resource/SubscriptionArticleResourceListResultModel';

export default class SubscriptionArticleResourceListResultViewModel extends SubscriptionArticleResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
